import { IMonHocActionTypes, eMonHocActionTypeIds } from "../../action-types/category/IMonHocActionType";
import { IMonHocReducer } from "../../reducer-model/category/IMonHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IMonHocReducer = {
    status: eReducerStatusBase.is_not_initialization,
    monHocs: []
}
export const monHocReducer = (state: IMonHocReducer=iniState, action: IMonHocActionTypes): IMonHocReducer => {
    switch (action.type) {
        case eMonHocActionTypeIds.LOAD_START:
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case eMonHocActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                monHocs: action.payload
            }
        case eMonHocActionTypeIds.LOAD_ERROR:
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}